import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ExternalToolsPage from "@/pages/admin/ExternalToolsPage";

export const Route = createFileRoute("/_admin/admin/quick-links")({
  head: () => pageHead("Admin · Quick Links", "AKIVA admin · quick links portal.", "/admin/quick-links", true),
  component: ExternalToolsPage,
});
